<template>
  <div class="full_page">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.full_page {
  @include room_f();
  background-color: #ffffff;
  z-index: 10;
}
</style>